import {useCallback} from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {IGameContextViewModel} from "../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {GameNavBarItemMobileComponent} from "../game-nav-bar-item.mobile.component";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core";

interface IGameNavBarItemComponentProps {
    gameContext: IGameContextViewModel;
}

export const DepositGameNavBarMobileComponent: React.FC<IGameNavBarItemComponentProps> = observer((props) => {
    const services = useServices();

    const _sentenceCase = useCallback((str: string): string => {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }, []);

    const _deposit = useCallback(() => {
        services.analytics.sendOrbitUserFlowEvent("Navigation", "Deposit", "InGameBottomNavBar");
        services.cashier.openDeposit({
            channel: {
                source: CHANNEL_SOURCE.casinoClient,
                area: AreaType.UserArea,
                element: CHANNEL_ELEMENTS.depositButton
            }
        });
    }, [services.cashier, services.analytics]);

    // a horrible hack, somehow necessary
    const depositLabel = services.translation.translate("DEPOSIT");
    const depositLabelSmallSize = services.mediaQuery.landscape && depositLabel.length > 8;

    const DepositIcon = services.theme.currentTheme.icons.wallet;

    return <GameNavBarItemMobileComponent Icon={DepositIcon} text={_sentenceCase(depositLabel)} onClick={_deposit} labelSmallSize={depositLabelSmallSize} />;
});
